const form = document.getElementById("letter-form");

const letterWrapper = document.getElementById("letter-wrapper");
const sendButton = form.querySelector("#send-button");
const letter = form.querySelector("#letter");

const lidOne = form.querySelector("#lid-one");
const lidTwo = form.querySelector("#lid-two");

const heartStamp = form.querySelector("#heart-stamp");

const thankYouMessage = document.getElementById("thank-you-message");
const speechBox = document.getElementById("speech-box");
const sharingOptions = document.querySelectorAll('input[name="sharing"]');

// Prayer Contact Form
const prayerContactForm = document.getElementById("prayer-contact-form");
const contactPrayer = document.getElementById("contact-prayer");
const contactName = document.getElementById("contact-name");
const contactAnonymous = document.getElementById("contact-anonymous");
const contactSharing = document.getElementById("contact-sharing");

letterWrapper.style.transition =
  "transform 0.6s cubic-bezier(.33, .9, .57, .96)";

let isSending = false;

// Letter enlarge for mobile
letter.addEventListener("focus", () => {
  letter.classList.add("letter-focused");
});

letter.addEventListener("blur", () => {
  letter.classList.remove("letter-focused");
});

// Prayer Modal
const prayerModal = document.getElementById("prayer-modal");
const modalClose = document.getElementById("modal-close");
const modalSendButton = document.getElementById("modal-send-button");
const prayerName = document.getElementById("prayer-name");

modalClose.addEventListener("click", () => {
  prayerModal.classList.remove("open");
});

sendButton.addEventListener("click", () => {
  prayerModal.classList.add("open");
});


function createLaunchEffects() {
  const streakContainer = document.createElement("div");
  streakContainer.className = "launch-streaks active";

  const burst = document.createElement("div");
  burst.className = "launch-burst";

  /*
   * Create randomized speed streaks.
   * More streaks make the launch look faster.
   */
  for (let index = 0; index < 24; index += 1) {
    const streak = document.createElement("span");
    streak.className = "launch-streak";

    const left = Math.random() * 100;
    const height = 80 + Math.random() * 230;
    const duration = 0.35 + Math.random() * 0.45;
    const delay = Math.random() * 0.2;

    streak.style.left = `${left}%`;
    streak.style.setProperty("--streak-height", `${height}px`);
    streak.style.setProperty("--streak-duration", `${duration}s`);
    streak.style.setProperty("--streak-delay", `${delay}s`);

    streakContainer.appendChild(streak);
  }

  form.appendChild(streakContainer);
  form.appendChild(burst);

  requestAnimationFrame(() => {
    burst.classList.add("active");
  });

  setTimeout(() => {
    streakContainer.remove();
    burst.remove();
  }, 1500);
}

function resetAnimation() {
  letter.classList.remove("letter-in-envelope");
  letterWrapper.classList.remove("launch-ready");

  letterWrapper.style.transition =
    "transform 0.6s cubic-bezier(.33, .9, .57, .96)";
  letterWrapper.style.transform = "translateY(0)";

  lidOne.style.transform = "rotateX(0deg)";
  lidTwo.style.transform = "rotateX(90deg)";

  sendButton.disabled = false;
  sendButton.textContent = "Send Prayer";

  isSending = false;
}

modalSendButton.addEventListener("click", () => {
  if (isSending) {
    return;
  }

  if (!letter.value.trim()) {
    letter.focus();
    return;
  }

  const selectedSharing = document.querySelector(
    'input[name="sharing"]:checked'
  );

  const prayerData = {
    prayer: letter.value.trim(),
    name: prayerName.value.trim() || null,
    anonymous: prayerName.value.trim() === "",
    sharing: selectedSharing ? selectedSharing.value : null
  };

  contactPrayer.value = prayerData.prayer;
  contactName.value = prayerData.name || "Anonymous";
  contactAnonymous.value = prayerData.anonymous ? "Yes" : "No";
  contactSharing.value = prayerData.sharing || "";


  isSending = true;
  sendButton.classList.add("hidden");
  prayerModal.classList.remove("open");

  // Open the envelope
  lidOne.style.transform = "rotateX(90deg)";
  lidOne.style.transitionDelay = "0s";

  lidTwo.style.transform = "rotateX(180deg)";
  lidTwo.style.transitionDelay = "0.25s";

  speechBox.style.opacity = "0";

  // Put the letter inside
  setTimeout(() => {
    letter.classList.add("letter-in-envelope");
  }, 500);

  // Close the envelope
  setTimeout(() => {
    lidOne.style.transform = "rotateX(0deg)";
    lidOne.style.transitionDelay = "0.25s";

    lidTwo.style.transform = "rotateX(90deg)";
    lidTwo.style.transitionDelay = "0s";
  }, 2500);

    setTimeout(() => {
        heartStamp.classList.add("stamped");
    }, 3000);

  // Move down slightly and shake before takeoff
  setTimeout(() => {
    letterWrapper.style.transform = "translateY(100px)";

    setTimeout(() => {
      letterWrapper.classList.add("launch-ready");
    }, 200);
  }, 3000);

  // Create the streaks and launch upward
  setTimeout(() => {
    createLaunchEffects();

    letterWrapper.classList.remove("launch-ready");
    letterWrapper.style.transition =
      "transform 1.1s cubic-bezier(.72, -.05, .88, .35)";

    letterWrapper.style.transform =
      "translateY(-1200px) rotate(5deg) scale(0.75)";
  }, 3900);

  // Remove the envelope after it flies away
  setTimeout(() => {
    letterWrapper.remove();
    form.style.display = "none";
  }, 5200);

  // Thank you message
  setTimeout(() => {
    thankYouMessage.style.display = "block";

    prayerContactForm.submit();
  }, 5300);
  
});